module.exports = __webpack_public_path__ + "media/images/services/terms1-d1656379612311d8b2e5073cc3e3a9a8.png";